'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOrValue;
function callOrValue(maybeFn, data) {
  if (typeof maybeFn === 'function') {
    return maybeFn(data);
  }
  return maybeFn;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/shape/build/util/callOrValue.js
// module id = 733
// module chunks = 0